type UnreadSupportRequestCount = {
  count: number;
};

export const useSupportRequestCount = () => {
  const count = useState<number>("unread-support-request-count", () => 0);
  const loading = useState<boolean>("unread-support-request-count-loading", () => false);
  const loaded = useState<boolean>("unread-support-request-count-loaded", () => false);
  const apiFetch = useApiFetch();

  const load = async (force = false) => {
    if (loading.value || (loaded.value && !force)) {
      return;
    }

    loading.value = true;
    try {
      const response = await apiFetch<UnreadSupportRequestCount>("/support-requests/unread-count");
      count.value = response.count;
      loaded.value = true;
    } catch {
      count.value = 0;
      loaded.value = false;
    } finally {
      loading.value = false;
    }
  };

  const reset = () => {
    count.value = 0;
    loaded.value = false;
  };

  const setCount = (value: number) => {
    count.value = value;
    loaded.value = true;
  };

  const decrement = () => {
    if (count.value > 0) {
      count.value -= 1;
    }
  };

  return {
    count: readonly(count),
    loading: readonly(loading),
    load,
    reset,
    setCount,
    decrement,
  };
};
